<template>
    <div>
		<el-form ref="loginform" :model="loginform"  :rules="rules" class="login-box">
            <img src="../../../../src/assets/images/logo.png" alt="img" class="logo" />
			<h3 class="login-title">欢迎登陆</h3>
			<el-form-item label="姓名" prop="accountName">
				<el-input v-model="loginform.user_account"></el-input>
			</el-form-item>
			<el-form-item label="密码" prop="passWord">
				<el-input v-model="loginform.user_password"></el-input>
			</el-form-item>
            <div>
                <el-button type="primary" @click="submitForm('loginform')">确定</el-button>
				<el-button>取消</el-button>
            </div>
		</el-form>
	</div>
</template>

<script>
import api from '../../../../src/api/api'
    export default {
        name: "mg_login",
        components: {  },
        data() {
            return {
                loginform: {
                    user_account:'superAdmin',
                    user_password:'123456'
                },
                rules:{
                    user_account: [
                        { required: true, message: '请输入姓名', trigger: 'blur' },
                    ],
                    user_password: [
                        { required: true, message: '请选择密码', trigger: 'change' }
                    ]
                }
            }
        },
        methods:{
            submitForm(formName) {
                this.$refs[formName].validate(async (valid) => {
                    if (valid) {
                        const _res = await api.getlogin( this.loginform );
                        if (_res.data.success) {
                            localStorage.setItem("CX_TOKEN", _res.data.data);
                            this.$router.push("/manage/mg_main");
                        } else {
                            this.$message.error(_res.data.message);
                        }
                       
                    } else {
                        this.$message.error('请输入正确用户名或密码!');
                        return false;
                    }
                });
            }
        }
    }
</script>


<style scoped>
	.login-box{
		width: 350px;
		margin:120px auto;
		border:1px solid #DCDFE6;
		padding:20px;
		border-radius:5px;
		box-shadow:0 0 30px #DCDFE6;
	}
	.login-title{
		text-align: center;
	}
</style>